import baseAPI from "@/api/base";
import { EditBucket, GetBucket, RegisterBucket } from "@/dtos/Bucket.dto";
import {
  BULK_DELETE_BUCKET_URL,
  DELETE_BUCKET_URL,
  EDIT_BUCKET_URL,
  GET_BUCKET_COUNT_URL,
  GET_BUCKET_STATS_URL,
  GET_BUCKET_URL,
  REGISTER_BUCKET_URL,
  TOGGLE_BUCKET_IS_ACTIVE_URL,
} from "@/utils/urls";
import { AxiosResponse } from "axios";

class Bucket {
  static getBuckets = async (getBucket: GetBucket): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_BUCKET_URL, {
      params: getBucket,
    });
    return response;
  };

  static getBucketStats = async (getBucket: GetBucket): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_BUCKET_STATS_URL, {
      params: getBucket,
    });
    return response;
  };

  static getBucketCounts = async (getBucket: GetBucket): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_BUCKET_COUNT_URL, {
      params: getBucket,
    });
    return response;
  };

  static registerBucket = async (registerBucket: RegisterBucket): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_BUCKET_URL, {
      ...registerBucket,
    });
    return response;
  };

  static editBucket = async (editBucket: EditBucket): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_BUCKET_URL, {
      ...editBucket,
    });
    return response;
  };

  static toggleBucketIsActive = async (editBucket: EditBucket): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(TOGGLE_BUCKET_IS_ACTIVE_URL, {
      ...editBucket,
    });
    return response;
  };

  static deleteBucket = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(`${DELETE_BUCKET_URL}/${id}`);
    return response;
  };

  static bulkDeleteBuckets = async (ids: string[]): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(BULK_DELETE_BUCKET_URL, { ids });
    return response;
  };

  static exportBuckets = async (params: { contactIds?: string[] }): Promise<AxiosResponse> => {
    return baseAPI.post("/report/buckets/export", params, { responseType: "blob" });
  };
}

export default Bucket;
